import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyDataMessageTitle: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.empty-data-message.empty-data-message-title',
		defaultMessage: "Get the last 12 weeks' data from your deployment tools",
		description:
			'Message displayed when user has no data at all, explaining what data the user needs.',
	},
	emptyDataMessageDescription: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.empty-data-message.empty-data-message-description',
		defaultMessage:
			'To view this report, you need deployment events from your CI/CD tool and commit events from your source code management tool.',
		description:
			'Message displayed when user has no data at all, explaining what data the user needs.',
	},
});
